<palantir-dialog class="palantir-select-item-dialog" [title]="title">
  <palantir-dialog-content
    #content
    class="palantir-scrollbar"
    [class.is-scrolling]="isScrolling()"
    cdkVirtualScrollingElement
  >
    <palantir-input [control]="searchControl" prefix="search-outline">
      <input type="text" [placeholder]="data.searchPlaceholderText" [formControl]="searchControl" />
    </palantir-input>

    @if (data.type === 'multiple' && items().length) {
      <div class="palantir-select-item-dialog__select-all">
        <palantir-checkbox
          [label]="data.selectAllText"
          invert="true"
          [attr.aria-selected]="isAllSelected()"
          [attr.indeterminate]="model.hasValue() && !isAllSelected()"
          (click)="toggleAll()"
        />
      </div>
    }

    <cdk-virtual-scroll-viewport autosize>
      <palantir-selectable-item
        *cdkVirtualFor="let item of items(); trackBy: trackByFn"
        [item]="item"
        [items]="allItems()"
        [model]="model"
        [type]="data.type"
        [limitItems]="limitItems()"
      />

      @if (isLoading()) {
        @for (_ of [].constructor(3); track $index) {
          <div class="palantir-select-item-dialog__skeleton-item">
            <palantir-skeleton class="palantir-select-item-dialog__skeleton-avatar" />
            <div class="palantir-select-item-dialog__skeleton-content">
              <palantir-skeleton class="palantir-select-item-dialog__skeleton-title" />
              <palantir-skeleton class="palantir-select-item-dialog__skeleton-subtitle" />
            </div>
          </div>
        }
      }
    </cdk-virtual-scroll-viewport>

    @if (!items().length && !isLoading()) {
      <palantir-text class="palantir-select-item-dialog__empty" type="description">{{
        data.emptyText
      }}</palantir-text>
    }
  </palantir-dialog-content>

  <palantir-dialog-actions>
    <palantir-button theme="outline" (click)="close()">
      {{ data.cancelText }}
    </palantir-button>

    <palantir-button (click)="confirm()" [attr.disabled]="!model.hasValue()">
      {{ data.successText }}
    </palantir-button>
  </palantir-dialog-actions>
</palantir-dialog>
